import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-tables',
  templateUrl: './tables.component.html',
  styleUrls: ['./tables.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TablesComponent {
  links: { name: string; route: string }[] = [
    { name: 'План продаж', route: 'sales-plan' },
    { name: 'План прибылей и убытков', route: 'profit-and-loss-plan' },
    { name: 'План движения денежных средств', route: 'cash-flow-plan' },
    { name: 'Баланс', route: 'balance' },
    { name: 'Результаты финансового анализа', route: 'results-of-financial-analysis' },
  ];
}
